import * as React from 'react';
import styles from './BurgerIcon.module.scss';

const topLineBurgerPath =
  'M4.44444 8.83908C3.65 8.83908 3 8.20029 3 7.41954C3 6.63879 3.65 6 4.44444 6H27.5556C28.35 6 29 6.63879 29 7.41954C29 8.20029 28.35 8.83908 27.5556 8.83908H4.44444Z';
const topLineClosePath =
  'M6.825 8.252c-.562-.561-.57-1.473-.017-2.025.552-.552 1.463-.544 2.025.018l16.342 16.342c.561.561.57 1.473.017 2.025-.552.552-1.463.544-2.025-.018L6.825 8.252z';

const bottomLineBurgerPath =
  'M4.44444 24.8391C3.65 24.8391 3 24.2003 3 23.4195C3 22.6388 3.65 22 4.44444 22H27.5556C28.35 22 29 22.6388 29 23.4195C29 24.2003 28.35 24.8391 27.5556 24.8391H4.44444Z';
const bottomLineClosePath =
  'M8.833 24.594c-.562.562-1.473.57-2.025.018-.552-.552-.545-1.463.017-2.025L23.167 6.245c.562-.562 1.473-.57 2.025-.018.552.552.544 1.464-.017 2.025L8.833 24.594z';

const BurgerIcon = ({ close }) => (
  <svg viewBox="0 0 32 32" className={styles.base} xmlns="http://www.w3.org/2000/svg">
    <path d={close ? topLineClosePath : topLineBurgerPath} />
    <path
      opacity={close ? 0 : 1}
      d="M4.44444 16.8391C3.65 16.8391 3 16.2003 3 15.4195C3 14.6388 3.65 14 4.44444 14H27.5556C28.35 14 29 14.6388 29 15.4195C29 16.2003 28.35 16.8391 27.5556 16.8391H4.44444Z"
    />
    <path d={close ? bottomLineClosePath : bottomLineBurgerPath} />
  </svg>
);

export default BurgerIcon;
